import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { FlightWidgetComponent } from 'src/components/common/modules/expedia-deals/flight/flight-widget/code-split/flight-widget-component';

const FlightModule = (props: ModuleProps) => {
  const flightWidgetProps = {
    ...props,
    data: {
      ...props.data,
      ...props,
      mccidData: {
        ...props.mccidData,
      },
    },
  };

  return (
    <>
      <FlightWidgetComponent {...flightWidgetProps} />
    </>
  );
};

export { FlightModule };
